// Constantes compartidas del modulo Agenda (colores de estado, horario visible, etc.)

export const STATUS_LABELS = {
  pending: 'Pendiente',
  confirmed: 'Confirmado',
  completed: 'Atendido',
  cancelled: 'Cancelado',
  no_show: 'No-show',
};

// Paleta coherente con la identidad earthy/luxury de la clínica (#8C7D70).
export const STATUS_COLORS = {
  pending: { bg: '#FBEFD9', text: '#9A6B22', border: '#E8C989', dot: '#D9A441' },
  confirmed: { bg: '#E3EDE1', text: '#4C6947', border: '#B9D2B2', dot: '#5B7A54' },
  completed: { bg: '#E8DFD8', text: '#6B5D50', border: '#C9BAAC', dot: '#8C7D70' },
  cancelled: { bg: '#EFEDE8', text: '#948A7C', border: '#D9D2C5', dot: '#A69C8C' },
  no_show: { bg: '#F4E1E1', text: '#A34B49', border: '#E8B9B9', dot: '#C2615E' },
};

export const STATUS_ORDER = ['pending', 'confirmed', 'completed', 'cancelled', 'no_show'];

export const SOURCE_LABELS = {
  manual: 'Creado por el equipo',
  public_booking: 'Reserva online',
  whatsapp_agent: 'Agente de WhatsApp',
};

// Ventana visible del calendario (hora local de la clínica, America/Chicago)
export const DAY_START_HOUR = 7;
export const DAY_END_HOUR = 21;

export const DAY_NAMES_ES = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'];

export function toLocalIsoString(date) {
  // Formatea un objeto Date como "YYYY-MM-DDTHH:mm:ss" SIN conversion a UTC,
  // ya que la agenda trabaja siempre en hora local de la clínica.
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
}
